"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _rcCheckbox = _interopRequireDefault(require("rc-checkbox"));
var _inputHOC = _interopRequireDefault(require("../Form/inputHOC"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledCheckbox = require("./StyledCheckbox");
var _excluded = ["prefixCls", "textLabel", "value", "children", "className", "indeterminate", "vertical", "style"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Checkbox = /*#__PURE__*/function (_React$Component) {
  function Checkbox() {
    var _this;
    (0, _classCallCheck2.default)(this, Checkbox);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Checkbox, [].concat(args));
    (0, _defineProperty2.default)(_this, "getValue", function () {
      var acceptedType = ['boolean', 'number'];
      var nextCheckValue = _this.props.checked !== undefined ? _this.props.checked : _this.props.defaultChecked;
      var nextCheckValueType = (0, _typeof2.default)(nextCheckValue);
      if (acceptedType.includes(nextCheckValueType)) {
        return !!nextCheckValue;
      }
      var nextValue = _this.props.value;
      var nextValueType = (0, _typeof2.default)(nextValue);
      if (acceptedType.includes(nextValueType)) {
        return !!nextValue;
      }
    });
    return _this;
  }
  (0, _inherits2.default)(Checkbox, _React$Component);
  return (0, _createClass2.default)(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        prefixCls = _this$props.prefixCls,
        textLabel = _this$props.textLabel,
        value = _this$props.value,
        children = _this$props.children,
        className = _this$props.className,
        indeterminate = _this$props.indeterminate,
        vertical = _this$props.vertical,
        style = _this$props.style,
        restProps = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      var checked = this.getValue();
      var cls = (0, _classnames.default)(className, (0, _defineProperty2.default)({}, "".concat(prefixCls, "-label"), !!prefixCls));
      var checkboxClass = (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-indeterminate"), indeterminate && !!prefixCls));
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/_react.default.createElement(_StyledCheckbox.StyledContainer, {
          theme: theme,
          checked: checked,
          key: value,
          indeterminate: indeterminate,
          prefixCls: prefixCls,
          cls: cls,
          vertical: vertical
        }, function (styledPrefix) {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_rcCheckbox.default, (0, _extends2.default)({
            key: value,
            value: value,
            prefixCls: styledPrefix,
            className: checkboxClass,
            checked: checked
          }, restProps)), (textLabel || children) && /*#__PURE__*/_react.default.createElement(_StyledCheckbox.StyledLabel, {
            style: style,
            $theme: theme
          }, textLabel || children));
        });
      });
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(Checkbox, "defaultProps", {
  prefixCls: '',
  defaultChecked: false,
  disabled: false,
  indeterminate: false
});
(0, _defineProperty2.default)(Checkbox, "propTypes", {
  textLabel: _propTypes.default.string,
  //value: PropTypes.string.isRequired,
  prefixCls: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  checked: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.bool]),
  defaultChecked: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.bool]),
  onChange: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  indeterminate: _propTypes.default.bool
});
Checkbox.displayName = 'Checkbox';
var _default = exports.default = (0, _inputHOC.default)(Checkbox);
/*

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import RcCheckbox from 'rc-checkbox';
import shallowEqual from 'shallowequal';

export default class Checkbox extends React.Component {
  static Group;
  static displayName = 'Checkbox';
  static defaultProps = {
    prefixCls: 'ykb-checkbox',
    indeterminate: false,
  };

  static contextTypes = {
    checkboxGroup: PropTypes.any,
  };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return (
      !shallowEqual(this.props, nextProps) ||
      !shallowEqual(this.state, nextState) ||
      !shallowEqual(this.context.checkboxGroup, nextContext.checkboxGroup)
    );
  }

  render() {
    const { props, context } = this;
    const {
      prefixCls,
      className,
      children,
      indeterminate,
      style,
      onMouseEnter,
      onMouseLeave,
      ...restProps
    } = props;
    const { checkboxGroup } = context;
    let checkboxProps = { ...restProps };
    if (checkboxGroup) {
      checkboxProps.onChange = () =>
        checkboxGroup.toggleOption({ label: children, value: props.value });
      checkboxProps.checked = checkboxGroup.value.indexOf(props.value) !== -1;
      checkboxProps.disabled =
        'disabled' in props ? props.disabled : checkboxGroup.disabled;
    }
    const classString = classNames(className, {
      [`${prefixCls}-wrapper`]: true,
    });
    const checkboxClass = classNames({
      [`${prefixCls}-indeterminate`]: indeterminate,
    });
    return (
      <label
        className={classString}
        style={style}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <RcCheckbox
          {...checkboxProps}
          prefixCls={prefixCls}
          className={checkboxClass}
        />
        {children !== undefined ? <span>{children}</span> : null}
      </label>
    );
  }
}
*/